export default "__VITE_ASSET__CKQucyHe__"